import { Component, OnInit } from '@angular/core';
import { slideInAnimation } from 'src/app/route-animate';

@Component({
  selector: 'app-newcorporate-page',
  templateUrl: './newcorporate-page.component.html',
  styleUrls: ['./newcorporate-page.component.css'],
  animations: [slideInAnimation],
})
export class NewcorporatePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
